import React from 'react'
import { H3, H6 } from '../Heading/index'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'
import DropInVideoPlayer, { DEFAULT_CONTROLS } from '../DropInVideoPlayer/index'

/**
 * The Gaia Ceo talks component
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text
 * @param {Function} props.onJoinButtonClick - The join gaia button event handler
 * @returns {JSX.Element} The CEO talks component
 */

function GaiaPlusCeoTalks (props) {
  const {
    staticText,
    onJoinButtonClick,
  } = props

  return (
    <div className="gaia-plus-page__ceo-talks">
      <div className="gaia-plus-page__ceo-talks-container">
        <H6>{staticText.get('ceoTalksTitleLine1')}</H6>
        <H3>{staticText.get('ceoTalksTitleLine2')}</H3>
        <div className="gaia-plus-page__ceo-talks-content">
          <div className="gaia-plus-page__ceo-talks-video">
            <div className="gaia-plus-page__video-container">
              <DropInVideoPlayer
                autoplay
                loop
                mediaId={139203}
                playsinline
                controls={{ type: DEFAULT_CONTROLS }}
              />
            </div>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              className="gaia-plus-page__ceo-talks-button"
              onClick={onJoinButtonClick}
            >
              {staticText.get('joinGaiaPlusNow')}
            </Button>
          </div>
          <div className="gaia-plus-page__ceo-talks-text">
            <p>{staticText.get('ceoTalksText1')}</p>
            <p>{staticText.get('ceoTalksText2')}</p>
            <p>{staticText.get('ceoTalksText3')}</p>
            <p>{staticText.get('ceoTalksText4')}</p>
            <div className="gaia-plus-page__ceo-talks-signature">
              <p>{staticText.get('jamesColquhoun')}</p>
              <p>{staticText.get('ceoGaia')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GaiaPlusCeoTalks
